import { render, staticRenderFns } from "./Bootstrap.vue?vue&type=template&id=1cb7491d&scoped=true&"
import script from "./Bootstrap.vue?vue&type=script&lang=js&"
export * from "./Bootstrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb7491d",
  null
  
)

export default component.exports